/*
Copyright (c) 2021.
*/

import maverickPortalhttp from '../../webService/webService';
import maverickPortalApiEndPoint from '../../../config/apiEndPoint';
import AuthService from '../../authService/AuthService';

const GetRecordTaskVideo = data => {
  return new Promise(function request(resolve) {
    maverickPortalhttp
      .makeRequest(
        `${maverickPortalApiEndPoint.getRecordTaskVideo.url}/${data.user_ID}/${data.project_ID}`,
        maverickPortalApiEndPoint.getRecordTaskVideo.methodType
      )
      .then(response => {
        const res = response.data;
        resolve({ res });
      });
  });
};

// const logout = () => {
//   return new Promise(function request(resolve) {
//     AuthService.logout();
//   resolve(true);
//   });
// };

export { GetRecordTaskVideo };
